import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ColDef, ColumnApi, GridApi } from 'ag-grid-enterprise';
import { LocalStorageService } from 'src/app/_services/localStorage/local-storage.service';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActionItemsGridRowRendererComponent } from 'src/app/components/_shared/action-items-grid-row-renderer/action-items-grid-row-renderer.component';
import { ProjectResourcesService } from 'src/app/_services/projectResources/project-resources.service';
import { AllocationService } from 'src/app/_services/resource-allocation/allocation.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ProjectService } from 'src/app/_services/project/project.service';

@Component({
  selector: 'app-resource-v2',
  templateUrl: './resource-v2.component.html',
  styleUrls: ['./resource-v2.component.scss']
})
export class ResourceV2Component implements OnInit {
  form: FormGroup;
  projectResourcesV2Form
  rowData: any; // row data and column definitions  
  public columnDefs: ColDef[]; 
  modeAction:number = 1 //1 - create // 2 - update
  private api: GridApi;  // gridApi and columnApi  
  private columnApi: ColumnApi;  
  defaultColDef:any;
  rowSelection:any
  tenantId: string;
  gridApi: any;
  gridColumnApi: any;
  gridLength = 0;
  sampleGridFrameworkComponents: any;
  selectedCheckboxData = []
  deleteConfirmationMsg = 'Are you sure you want to delete';
  currentUser: any;
  currentProjectId: any;
  parentProjectId: any;
  selectedRow: any;
  userDropdownList: Array<any> = [];
  getUserName: any;
  isPMOLeadORManager: boolean = false;
  isAdministrator: boolean = false;
  isPMOAdmin: boolean = false;

  constructor(
    private router: Router,
    private storageService: LocalStorageService,
    private route: ActivatedRoute,
    private projectResourcesService: ProjectResourcesService,
    private allocationService: AllocationService,
    private snackBar: MatSnackBar,
    private projectService: ProjectService,
  ) { 
    this.defaultColDef = {
      flex: 1,
      minWidth: 100,
      resizable: true,
    };
    this.rowSelection = 'multiple';
    this.columnDefs = this.createColumnDefs(); 
   
    this.sampleGridFrameworkComponents = {
      actionRowRendererComponent: ActionItemsGridRowRendererComponent
    };
    this.projectResourcesV2Form = new FormGroup({
      id :new FormControl(''),
      projectV2Id :new FormControl(''),
      projectV2Name :new FormControl(''),
      projectV2Code :new FormControl(''),
      userId : new FormControl(''),
      userName : new FormControl(''),
      projectRole: new FormControl(''),
      projectAdminBoolean: new FormControl(''),
    })
  }

  ngOnInit(): void {
    this.tenantId = this.storageService.get('tenantId');
    this.currentUser = JSON.parse(this.storageService.get('currentUser'));
    this.isAdministrator = this.currentUser.roles.includes('RoleAdministrator');
    this.isPMOAdmin = this.currentUser.roles.includes('RolePmoAdministrator');
    this.currentProjectId = this.route.snapshot.queryParamMap.get('projectID');
    this.parentProjectId = this.route.snapshot.queryParamMap.get('parentId');
    this.getProjectByIdV2(this.currentProjectId);
    this.getProjectV2ResourceByProjectId();
    this.getUserList();
  }

  getProjectByIdV2(id) {
    this.projectService.getProjectV2(id).subscribe((response: any) => {
      if (response) {
        if(response.projectManagerId === this.currentUser.id || response.projectLeadId === this.currentUser.id){
          this.isPMOLeadORManager = true;
        }
        else if(this.parentProjectId){
          this.projectService.getProjectV2(this.parentProjectId).subscribe((response: any) => {
            if(response.projectManagerId === this.currentUser.id || response.projectLeadId === this.currentUser.id){
              this.isPMOLeadORManager = true;
            }
          });
        }
      }
    }, error => {
      this.openSnackBar('ERROR: cannot get project by id: ' + error);
    })
  }

  getUserList() {
    this.userDropdownList = [];
    this.allocationService.getUserDetails().subscribe((response) => {
      this.userDropdownList = response.map((item: any) => `${item.id} . ${item.firstName} ${item.lastName}`);
    });
  } 

  //Get The Resource Project List
  getProjectV2ResourceByProjectId(){
    this.projectResourcesService.getAllProjectV2ResourcesByProjectId(this.currentProjectId).subscribe((response: any) => {
      this.rowData = response;
    });
  }

  // one grid initialisation, grap the APIs and auto resize the columns to fit the available space  
  onGridReady(params): void {
    this.api = params.api;
    this.columnApi = params.columnApi;
    this.api.sizeColumnsToFit();
  }

  // create column definitions  
  private createColumnDefs() {
    return [
      // {
      //   headerName: "ProjectId",
      //   field: "projectV2Id",
      //   valueGetter: function(params){
      //     let project = params.data.projectV2Id + " . " + params.data.projectV2Name;
      //     return project;
      //   },
      //   filter: true,
      //   editable: false,
      //   sortable: true,
      //   headerCheckboxSelection: this.isFirstColumn,
      //   checkboxSelection: this.isFirstColumn,
      // },
      {
        headerName: "User Name",
        field: "userName",
        filter: true,
        editable: false,
        sortable: true,
        headerCheckboxSelection: this.isFirstColumn,
        checkboxSelection: this.isFirstColumn,
      },
      {
        headerName: "Project Role",
        field: "projectRole",
        filter: true,
        editable: false,
        sortable: true,
      },
      {
        headerName: "Project Admin",
        field: "projectAdminBoolean",
        filter: true,
        editable: false,
        sortable: true,
      },
    ]
  }

  onSelectionChanged(event) {
    this.selectedCheckboxData = []
    let select = event.api.getSelectedNodes();
    for (let item of select) {
      this.selectedCheckboxData.push(item.data)
    }
  }

  isFirstColumn(params) {
    const displayedColumns = params.columnApi.getAllDisplayedColumns();
    const thisIsFirstColumn = displayedColumns[0] === params.column;
    return thisIsFirstColumn;
  }

  createOpenModal() {
    this.modeAction = 1;
    this.projectResourcesV2Form.reset();
  }

  editOpenModal() {
    this.modeAction = 2;
    const data = this.selectedCheckboxData[0];
    this.projectResourcesV2Form.patchValue({
      ...data,
      userName: data.userId + ' . ' + data.userName
    });
  }

  backToMyProjectV2() {
    if (this.parentProjectId) {
      this.router.navigate([this.tenantId + '/dashboard/project/project-list-v2/sub-project-v2'], { queryParams: { projectID: this.parentProjectId } });
    } else {
      this.router.navigate([this.tenantId + '/dashboard/project/project-list-v2/myproject-v2']);
    }
  }

  openProjectTab(param) {
    if (this.parentProjectId) {
      this.router.navigate([this.tenantId + `/dashboard/project/project-list-v2/${param}`], { queryParams: { projectID: this.currentProjectId, parentId: this.parentProjectId } }); // pass current project id as parameter
    }
    else {
      this.router.navigate([this.tenantId + `/dashboard/project/project-list-v2/${param}`], { queryParams: { projectID: this.currentProjectId } }); // pass current project id as parameter
    }
  }

    // Pop-up message
  openSnackBar(message: string) {
    this.snackBar.open(message, 'Close', { duration: 3000 });
  }

  createProjectV2Resource(){
    let resourceData : String;
    resourceData = this.projectResourcesV2Form.get('userName').value.toString().replaceAll(",", " , ");
    let details = {
      projectV2Id : this.currentProjectId,
      users: resourceData,
      projectRole: this.projectResourcesV2Form.get('projectRole').value,
      projectAdminBoolean: this.projectResourcesV2Form.get('projectAdminBoolean').value,
    }
    this.projectResourcesService.createBulkProjectV2Resources(details).subscribe((response: any) => {
      this.getProjectV2ResourceByProjectId();
      $('#closeCreateModal').trigger("click");
    });
  }

  updateProjectV2Resource(){
    let details = {
      projectV2Id : this.currentProjectId,
      userId: this.projectResourcesV2Form.get('userName').value?.toString().split(' . ')[0],
      projectRole: this.projectResourcesV2Form.get('projectRole').value,
      projectAdminBoolean: this.projectResourcesV2Form.get('projectAdminBoolean').value,
    }
    this.projectResourcesService.updateProjectV2Resources(details, this.selectedCheckboxData[0].id).subscribe(res => {
      this.getProjectV2ResourceByProjectId();
      this.selectedCheckboxData = []
      $('#closeCreateModal').trigger("click");
    });
  }
}
